import { useEffect, useState } from 'react'

const store: { [key: string]: any } = {}
let cnt = 0

const addGlobalStateEntry = (key: string, defaultValue?: any) => {
  while (typeof defaultValue === 'function') {
    defaultValue = defaultValue()
  }
  store[key] = {
    setState: (val: any) => setGlobalState(key, val),
    listeners: new Set(),
    state: defaultValue,
  }
}

export const setGlobalState = (key: string, val: any, dontEmit = false) => {
  if (key in store) {
    if (store[key].state !== val) {
      store[key].state = val
      if (!dontEmit) {
        cnt++
        store[key].listeners.forEach((fn: (cnt: number) => void) => fn(cnt))
      }
    }
  } else {
    addGlobalStateEntry(key, val)
  }
}

export const getGlobalState = (key: string) => {
  return (key in store && store[key].state) || undefined
}

const useGlobalState = (key: string, defaultValue?: any) => {
  if (!(key in store)) {
    addGlobalStateEntry(key, defaultValue)
  }

  useEffect(() => {
    return () => {
      store[key].listeners.delete(setState)
    }
  }, [key])

  const [, setState] = useState(cnt)
  store[key].listeners.add(setState)

  return [store[key].state, store[key].setState]
}

export default useGlobalState
